import React from 'react';
import classNames from 'classnames';
var Line = function (_a) {
    var x1 = _a.x1, x2 = _a.x2, y1 = _a.y1, y2 = _a.y2, className = _a.className, _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 2 : _b;
    return (React.createElement("line", { x1: x1, y1: y1, x2: x2, y2: y2, strokeWidth: strokeWidth, className: classNames('line', className) }));
};
export default Line;
//# sourceMappingURL=Line.js.map